import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    bindActionCreators,
    Dispatch
} from 'redux';
import _ from 'lodash';
import {renderToString} from 'react-dom/server'
import {keys} from 'ts-transformer-keys';
import memoize from 'memoize-one';
import parse from 'html-react-parser';

import {__} from '~/shared/src/utilities/messageCatalog';
import metaModel from '~/shared/src/utilities/metaModel';
import Item, {
    ItemAttributesForCreation,
    ItemAttributesSettable
} from '~/shared/src/ci/Item';
import {
    ReferenceAttributesForCreation,
    ReferenceAttributesSettable
} from '~/shared/src/ci/Reference';
import User from '~/shared/src/model/User';
import {
    ColumnConfig,
    ColumnDefinition,
    ColumnFilter
} from '~/shared/src/validationSchemes/modules/overview';
import {
    OverviewInitialGroupState,
    OverviewLinkTarget
} from '~/shared/src/utilities/overview';
import {
    ColumnKeyToFieldMapping,
    LoadConfigParameters,
    LoadConfigResult,
    LoadDataParameters,
    LoadDataResult,
    LoadMetaDataRowData,
    OpenDetailViewConfig
} from '~/shared/src/utilities/modules/overview';
import objectUtils from '~/shared/src/utilities/objectUtils';
import {Query} from '~/shared/src/utilities/query';
import {
    buildDataDescriptor,
    DataStructure,
    ItemDataDescriptor
} from '~/shared/src/utilities/dataStructure';
import messageUtils from '~/shared/src/utilities/messageUtils';
import {Visibility} from '~/shared/src/utilities/modules/form';
import {
    Action,
    getResolvedConfigs
} from '~/shared/src/utilities/action';
import {Function} from '~/shared/src/utilities/function';

import {Button} from 'primereact/button';
import {Card} from 'primereact/card';
import {ChevronDownIcon} from 'primereact/icons/chevrondown';
import {ChevronRightIcon} from 'primereact/icons/chevronright';
import {Column} from 'primereact/column';
import {confirmPopup} from 'primereact/confirmpopup';
import {Dialog} from 'primereact/dialog';
import {IconUtils} from 'primereact/utils';

import Toolbar, {
    ComponentProps as ToolbarComponentProps,
    componentProps as toolbarComponentProps
} from '~/frontend/src/components/base/Overview/Toolbar';
import DataTable, {
    defaultProps as dataTableDefaultProps,
    DefaultProps as DataTableDefaultProps,
    Props as DataTableProps,
    ComponentProps as DataTableComponentProps,
    componentProps as dataTableComponentProps,
    AllProps as DataTableAllProps,
    CellEditorData as DataTableCellEditorData,
    cellEditorDataKeys as dataTableCellEditorDataKeys,
    ChangedCellValues,
    ActionColumns
} from '~/frontend/src/components/base/DataTable/index';
import Form, {
    FunctionParameters,
    Variables
} from '~/frontend/src/components/base/Form';
import LoadingMaskPanel from '~/frontend/src/components/base/LoadingMaskPanel';
import GenericForm from '~/frontend/src/components/base/ItemFinder/detail/PropertiesPanel';
import {
    StoreState,
    Thunk
} from '~/frontend/src/store';
import xhr from '~/frontend/src/utilities/xhr';
import {
    getColumnConfigFromColumnDefinition
} from '~/frontend/src/components/base/DataTable/utilities';
import {
    getDefaultViewProps,
    extractViewPropsFromProps,
    buildPropsFromViewProps,
    viewSelectorPanelPropsCompare
} from '~/frontend/src/components/base/Overview/utilities';
import {isDataModified} from '~/frontend/src/utilities/dataUtils';
import actionMixin, {
    ActionMixinInterface
} from '~/frontend/src/utilities/ActionMixin';
import {getSubPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/utilities';
import {isInvalidHTML} from '~/frontend/src/utilities/valueRenderers';
import ActionMixin from '~/frontend/src/utilities/ActionMixin';

import openPanel, {
    OpenPanel,
    PanelPropsWithPanelType
} from '~/frontend/src/actions/panelManager/openPanel';
import openPanelForItemType, {OpenPanelForItemType} from '~/frontend/src/actions/panelManager/openPanelForItemType';
import clearPanelProps, {ClearPanelProps} from '~/frontend/src/actions/panelManager/clearPanelProps';
import * as PanelActions from '~/frontend/src/actions/panel/common';
import {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import {SetParamsAction} from '~/frontend/src/actions/panel/common/setParams';
import loadData, {
    LoadData
} from '~/frontend/src/actions/data/loadData';
import * as IntercomActions from '~/frontend/src/actions/intercom';
import {SetMessage} from '~/frontend/src/actions/intercom';
import {
    ElusiveDataState,
    PanelElusiveDataState
} from '~/frontend/src/reducers/elusiveData';
import {XhrComponentState} from '~/frontend/src/reducers/xhr';
import {
    clearElusiveData,
    ClearElusiveData,
    clearElusiveDataForSubpanels,
    ClearElusiveDataForSubpanels,
    setElusiveData,
    SetElusiveDataAction,
    unsetElusiveData,
    UnsetElusiveDataAction
} from '~/frontend/src/actions/elusiveData';
import addItem, {AddItem} from '~/frontend/src/actions/data/addItem';
import deleteItem, {DeleteItem} from '~/frontend/src/actions/data/deleteItem';
import updateItem, {UpdateItem} from '~/frontend/src/actions/data/updateItem';
import addReference, {AddReference} from '~/frontend/src/actions/data/addReference';
import deleteReference, {DeleteReference} from '~/frontend/src/actions/data/deleteReference';
import updateReference, {UpdateReference} from '~/frontend/src/actions/data/updateReference';
import {Tooltip} from 'primereact/tooltip';


type PanelElusiveData = PanelElusiveDataState & PanelErrorData & PanelDirtyData & DataTableCellEditorData & {
    changedCellValues? : ChangedCellValues;
};


const Actions = Object.assign( { openPanel, openPanelForItemType }, PanelActions, { clearPanelProps, loadData, clearElusiveData, clearElusiveDataForSubpanels, setElusiveData, unsetElusiveData, addItem, deleteItem, updateItem, addReference, updateReference, deleteReference }, IntercomActions ) as any;
type SetParam = <K extends keyof ( ComponentProps )>( panelKey : string, paramKey : K, paramValue : ComponentProps[K] ) => SetParamAction;
type SetParams = ( panelKey : string, panelProps : Partial<ComponentProps> ) => SetParamsAction;
type SetElusiveData = ( panelKey : string, data : PanelElusiveData ) => SetElusiveDataAction;
type UnsetElusiveData = ( panelKey : string, data : PanelElusiveData ) => UnsetElusiveDataAction;


export type DefaultProps = DataTableDefaultProps & {

    /**
     * Load search result from backend.
     */
    doSearch? : boolean;

    linkTarget? : OverviewLinkTarget;

    /**
     * Is this component standalone.
     */
    mode? : 'standalone' | 'embedded' | 'embeddedNoCard';

    /**
     * View the overview as configured
     */
    showViewAsConfigured? : boolean;

    queryType? : Query[ 'type' ];

    loadDataRoute? : string;

    readOnly? : boolean;

    deletable? : boolean;

    /**
     * The visibility of the toolbar for the overview.
     */
    toolbarVisibility? : Visibility;

    initialGroupState? : OverviewInitialGroupState;

    usePaging? : boolean;
};
export const defaultProps : Required<DefaultProps> = {
    ...dataTableDefaultProps,

    doSearch            : true,
    linkTarget          : 'panel',
    mode                : 'standalone',
    showViewAsConfigured: false,
    queryType           : 'DataStructure',
    loadDataRoute       : 'overview/loadData',
    readOnly            : false,
    deletable           : false,
    toolbarVisibility   : 'visible',
    initialGroupState   : 'expanded',
    usePaging           : true
};

export type Props = DataTableProps & {

    /**
     * The key of the overview config.
     */
    viewKey : string;

    /**
     * A hash of the loaded overview configuration to detect changes.
     */
    configHash? : string;

    /**
     * The computed props from the loaded config.
     */
    defaultProps? : Pick<DataTableComponentProps, 'columns' | 'filters' | 'fixFilters' | 'sorters' | 'doSearch' | 'autoLayout' | 'forceFit' | 'editMode' | 'rowStyling'>;

    /**
     * Function invoked if config was successfully loaded.
     *
     * @param {LoadConfigResult} config
     */
    onConfigLoad? : ( config : LoadConfigResult ) => void;

    /**
     * Function invoked if config was successfully loaded.
     *
     * @param {LoadDataResult} config
     */
    onDataLoad? : ( config : LoadDataResult ) => void;

    /**
     * Additional parameters which have to be relayed to the CFG:Query used to load the results.
     */
    additionalQueryParameters? : Required<LoadDataParameters[ 'parameters' ]>;

    openDetailViewConfig? : OpenDetailViewConfig;

    columnKeyToFieldMapping? : ColumnKeyToFieldMapping;

    groupingColumn? : string;
    groupingHeader? : string;

    panelConfigIds? : number[];

    /**
     * The transformer for the module (component) state.
     * NOTE: Have to been set (in opposition to be a default) to be included in the state anyway!
     */
    moduleTransformer? : string;

    actions? : Action[];

    functions? : Function[];

    /**
     * The itemId of the parent in a tree.
     * Only valid if running in a tree context.
     */
    treeParentItemId? : number;

    /**
     * The itemId of the root of a tree.
     * Only valid if running in a tree context.
     */
    treeRootItemId? : number;

    /**
     * The tree variables
     */
    treeVariables? : Variables;

    /**
     * Getter for the tree variables
     */
    treeSetVariables? : ( variables : Variables ) => void;

};

export type ComponentProps = DefaultProps & Props;
export const componentProps = keys<ComponentProps>();

type StateProps = {

    /**
     * The running requests belonging to this component (uid).
     *
     * Will be mapped from global state.
     */
    xhrRequestsForComponent? : XhrComponentState;

    /**
     * The full elusiveData
     */
    allElusiveData? : ElusiveDataState;

    /**
     * The elusive data (not persisted by redux store) for this component.
     *
     * Will be mapped from global state.
     */
    elusiveData? : PanelElusiveData;

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;
};

type ActionPropsRaw = {
    // panel manager actions
    openPanel : OpenPanel;
    openPanelForItemType : OpenPanelForItemType;

    // common panel actions
    setParam : SetParam;
    setParams : SetParams;
    clearPanelProps : ClearPanelProps;

    // data actions
    loadData : LoadData;
    addItem : AddItem;
    deleteItem : DeleteItem;
    updateItem : UpdateItem;
    addReference : AddReference;
    updateReference : UpdateReference;
    deleteReference : DeleteReference;


    // elusiveData actions
    clearElusiveData : ClearElusiveData;
    clearElusiveDataForSubpanels : ClearElusiveDataForSubpanels;
    setElusiveData : SetElusiveData;
    unsetElusiveData : UnsetElusiveData;

    // intercom actions
    setMessage : SetMessage;
};
type ReplaceReturnType<T extends ( ...a : any ) => any, TNewReturn> = ( ...a : Parameters<T> ) => TNewReturn;
type ActionProps = {
    [K in keyof ActionPropsRaw] : ReplaceReturnType<ActionPropsRaw[K], ReturnType<ActionPropsRaw[K]> extends Thunk<any> ? ReturnType<ReturnType<ActionPropsRaw[K]>> : void>;
};

export type AllProps = Required<DefaultProps> & Props & StateProps & ActionProps;


type State = {
    isDirty : boolean;
    errorCount : number;
    errorTooltip? : string | JSX.Element | ( string | JSX.Element )[];
    errorMessage? : string | JSX.Element | ( string | JSX.Element )[];
    showEditItemDialog : boolean;
    editItem? : Item;
    editPanelConfig? : any;
    forceRender : number;
};


// define interface for Form component to apply methods from mixin
export interface Overview extends Component<AllProps, State>, ActionMixinInterface {
}


/**
 * Overview
 */
export class Overview extends Component<AllProps, State> {

    static defaultProps = defaultProps;

    static configRequestUid = 'loadConfig' as string;
    static dataRequestUid = 'loadData' as string;

    static viewSelectorModule = 'Overview';


    dynamicFunctionGlobalParameterKeys? : string[];
    dynamicFunctionGlobalParameterValues? : any[];
    dynamicFunctionGlobalParameters? : FunctionParameters;
    variables? : Variables;

    /* properties *************************************************************************************************************************/

    /**
     * @param props
     */
    constructor( props : AllProps ) {
        super( props );

        this.state = {
            isDirty           : false,
            errorCount        : 0,
            showEditItemDialog: false,
            forceRender       : 0
        };

        this.getActionColumns = memoize( this.getActionColumns );
        this.getColumnGrouping = memoize( this.getColumnGrouping );
        this.getSearchColumns = memoize( this.getSearchColumns );

        this.loadData = this.loadData.bind( this );
        this.restoreDeleteCellRenderer = this.restoreDeleteCellRenderer.bind( this );
        this.onEditItemDialogHide = this.onEditItemDialogHide.bind( this );
        this.onEditItemDialogOkButtonClick = this.onEditItemDialogOkButtonClick.bind( this );
        this.onEditItemDialogCancelButtonClick = this.onEditItemDialogCancelButtonClick.bind( this );
        this.onRowClick = this.onRowClick.bind( this );
        this.onRowDataChange = this.onRowDataChange.bind( this );
        this.onRowDataRevert = this.onRowDataRevert.bind( this );
    }

    /**
     * REDUX stuff
     */
    static getDerivedStateFromProps( props : AllProps, state : State ) : Partial<State> {
        const {
                  dataContext,
                  schema,
                  elusiveData
              }                       = props,
              retVal : Partial<State> = {
                  isDirty     : isDataModified( dataContext, schema ),
                  errorCount  : 0,
                  errorTooltip: undefined,
                  errorMessage: undefined
              };

        // errors
        if ( elusiveData?.errorData ) {
            const errorData = elusiveData.errorData;

            retVal.errorCount = errorData.count;

            retVal.errorTooltip = <div key="error" className="yn-tooltip-error">
                <div className="yn-tooltip-header">
                    {__( 'YN.base.frontend.dataTable.tooltip.error.title' )}
                </div>
                {errorData.tooltip}
            </div>;

            retVal.errorMessage = <>
                <div className="yn-error-message">
                    {__( 'YN.base.frontend.dataTable.couldNotSaveWhileErrors.text' )}
                </div>
                <hr className="yn-error-ruler"/>
                <div className="yn-error-suberror">
                    {errorData.message}
                </div>
            </>;
        }

        return retVal;
    }

    /**
     * REACT lifecycle method
     */
    componentDidMount() {
        this.init();
    }

    /**
     * REACT lifecycle method
     */
    shouldComponentUpdate( nextProps : AllProps, nextState : State ) : boolean {
        const changedProps = objectUtils.getDiffKeys(
                  this.props,
                  nextProps,
                  [
                      'actionColumns',
                      'allElusiveData',
                      'cellEditorErrors',
                      'columnDefaults',
                      'columnDefinitions',
                      'columns',
                      'dataStructure',
                      'filters',
                      'fixFilters',
                      'footer',
                      'rowClass',
                      'rowExpansionTemplate',
                      'rowGroupFooterTemplate',
                      'rowGroupHeaderTemplate',
                      'rowState',
                      'rowStyling',
                      'searchColumns',
                      'sorters',
                      'user',
                      'xhrRequestsForComponent'
                  ],
                  [
                      'elusiveData'
                  ],
                  [
                      'reload',
                      'onRowClick'
                  ]
              ),
              stateChanged = this.state !== nextState;

        let retVal : boolean = false;

        if (
            stateChanged
            || changedProps.length === 1
            || changedProps.length > 2
            || ( changedProps.length === 2 && !changedProps.includes( 'elusiveData.lastParams' ) && !changedProps.includes( 'elusiveData.columnsCache' ) )
        ) {
            retVal = true;
        }

        if ( changedProps.includes( 'additionalQueryParameters' ) ) {
            this.props.setParam( nextProps.uid, 'doSearch', true );
        }

        // load config if not
        if ( nextProps.viewKey && ( !nextProps?.columnDefinitions?.length || !nextProps?.dataStructure ) && !nextProps.xhrRequestsForComponent?.loadConfig ) {
            void this.loadConfig();
        }

        return retVal;
    }


    /* event handlers *********************************************************************************************************************/

    /**
     * Handler for dataTables rowClick
     *
     * @private
     */
    onRowClick( field : string, rowData : LoadMetaDataRowData, event : React.MouseEvent<HTMLElement> ) {
        const {
                  columnDefinitions,
                  dataContext,
                  dataStructure,
                  linkTarget,
                  openDetailViewConfig,
                  panelConfigIds,
                  schema,
                  valueFieldMapping,
                  columnKeyToFieldMapping
              }                   = this.props,
              columnDefinition    = columnDefinitions.find( colDef => colDef.field === field ) as ColumnDefinition,
              editFormDataContext = this.getEditFormDataContext();

        let retVal : boolean = false,
            panelConfig : PanelPropsWithPanelType | undefined;

        // 1. handle column panelConfigs (applies only for DataStructure query)
        if ( columnDefinition?.panelConfigIds?.length && columnDefinition?.dataDescriptor?.dataObject ) {
            const columnItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, columnDefinition?.dataDescriptor?.dataObject ) as ItemDataDescriptor,
                  columnItemId               = rowData[ columnItemIdDataDescriptor?.alias ],
                  columnItem                 = global.data[ dataContext ]?.items[ columnItemId ];

            panelConfig = user?.getPanelConfigFromIdList( columnDefinition.panelConfigIds );

            if ( columnItem && panelConfig ) {
                let editItem : Item | undefined;

                retVal = true;

                if (
                    panelConfig.panelType !== 'FinderOverview'
                    && panelConfig.panelType !== 'Overview'
                    && panelConfig.panelType !== 'QueryExecute'
                    && panelConfig.panelType !== 'XmlImport'
                ) {
                    panelConfig.rootItemId = columnItem.id;
                }

                if ( linkTarget === 'popup' && ( panelConfig.panelType === 'FinderDetail' || panelConfig.panelType === 'Form' ) ) {
                    // clone item
                    editItem = global.data[ editFormDataContext ].items[ columnItem.id ].clone( undefined, undefined, editFormDataContext );
                }

                if ( editItem ) {
                    this.hideEditItemDialog();

                    this.setState( {
                        showEditItemDialog: true,
                        editItem,
                        editPanelConfig   : panelConfig
                    } );
                }
                else {
                    void this.props.openPanel( panelConfig, undefined, event );
                }
            }
        }

        // 2. handle overview (applies only for Cypher / SQL queries if openDetailViewConfig is defined or for DataStructure queries)
        if ( !retVal ) {
            let idOrKey : number | string | undefined,
                itemSchema : Schema | undefined,
                itemTypeName : string | undefined;

            // 1. try getting idOrKey and itemType name by openDetailViewConfig
            if ( openDetailViewConfig ) {
                idOrKey = rowData[ openDetailViewConfig.queryFieldName ]
                    ?? rowData[ valueFieldMapping?.[ openDetailViewConfig.queryFieldName ] ?? '' ]
                    ?? rowData[ columnKeyToFieldMapping?.[ openDetailViewConfig.queryFieldName ] ?? '' ];
                itemTypeName = rowData[ openDetailViewConfig.itemTypeNameOrQueryFieldName ]
                    ?? rowData[ valueFieldMapping?.[ openDetailViewConfig.itemTypeNameOrQueryFieldName ] ?? '' ]
                    ?? rowData[ columnKeyToFieldMapping?.[ openDetailViewConfig.itemTypeNameOrQueryFieldName ] ?? '' ]
                    ?? openDetailViewConfig.itemTypeNameOrQueryFieldName;
            }

            // 2. try getting idOrKey and itemType name by rowItem
            if ( !idOrKey || !itemTypeName ) {
                const rowItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
                      rowItemId               = rowData[ rowItemIdDataDescriptor?.alias ],
                      rowItem                 = global.data[ dataContext ]?.items[ rowItemId ];

                if ( rowItem ) {
                    idOrKey = rowItem.id;
                    itemSchema = rowItem.schema;
                    itemTypeName = rowItem.itemType.name;
                }
            }

            if ( idOrKey && itemTypeName ) {
                panelConfig = !event.altKey
                    ? user?.getPanelConfigFromIdList( panelConfigIds ?? [] )
                    : undefined;

                if ( !panelConfig ) {
                    panelConfig = user?.getDefaultPanelPropsForItemType( schema, itemTypeName, event.altKey, undefined, [ 'FinderOverview', 'Overview', 'XmlImport' ] );
                }

                if ( panelConfig ) {
                    let editItem : Item | undefined;

                    retVal = true;

                    panelConfig = {
                        ...panelConfig,

                        schema: itemSchema ?? schema
                    };

                    if (
                        panelConfig.panelType !== 'FinderOverview'
                        && panelConfig.panelType !== 'Overview'
                        && panelConfig.panelType !== 'QueryExecute'
                        && panelConfig.panelType !== 'TreeTest'
                        && panelConfig.panelType !== 'XmlImport'
                    ) {
                        panelConfig.rootItemId = typeof idOrKey === 'number' ? idOrKey : undefined;
                        panelConfig.rootItemKey = typeof idOrKey === 'string' ? idOrKey : undefined;

                        if (
                            panelConfig.panelType !== 'BusinessProcessDesignerView'
                            && panelConfig.panelType !== 'ChartDesignerView'
                            && panelConfig.panelType !== 'FormDesignerView'
                            && panelConfig.panelType !== 'GraphDesignerView'
                            && panelConfig.panelType !== 'MapSearchView'
                            && panelConfig.panelType !== 'OverviewDesignerView'
                        ) {
                            panelConfig.rootItemType = typeof idOrKey === 'string' ? itemTypeName : undefined;
                        }
                    }

                    if ( linkTarget === 'popup' && ( panelConfig.panelType === 'FinderDetail' || panelConfig.panelType === 'Form' ) && typeof idOrKey === 'number' ) {
                        // clone item
                        editItem = global.data[ dataContext ]?.items?.[ idOrKey ]?.clone( undefined, undefined, editFormDataContext );
                    }

                    if ( editItem ) {
                        this.hideEditItemDialog();

                        this.setState( {
                            showEditItemDialog: true,
                            editItem,
                            editPanelConfig   : panelConfig
                        } );
                    }
                    else {
                        void this.props.openPanel( panelConfig, undefined, event );
                    }
                }
            }
        }

        return retVal;
    }

    onRowToggle( groupColumnValue : string ) {
        const {
                  expandedRows,
                  groupingColumn,
                  uid
              }               = this.props,
              newExpandedRows = ( [] as any[] ).concat( expandedRows ?? [] ),
              index           = newExpandedRows.findIndex( eR => Object.values( eR )?.[ 0 ] === groupColumnValue );

        if ( index === -1 ) {
            newExpandedRows.push( { [ `rowData.${groupingColumn}` ]: groupColumnValue } );
        }
        else {
            newExpandedRows.splice( index, 1 );
        }

        this.props.setParam( uid, 'expandedRows', newExpandedRows );
    }

    /**
     * Handler for action columns rowAction
     *
     * @param {'delete' | 'restore'} type
     * @param {LoadMetaDataRowData} rowData
     */
    onRestoreDeleteAction( type : 'delete' | 'restore', rowData : LoadMetaDataRowData ) {
        const {
                  dataContext,
                  dataStructure,
                  elusiveData,
                  schema,
                  uid
              }                           = this.props,
              value                       = ( elusiveData?.metaData?.rowData ?? [] ) as LoadMetaDataRowData[],
              rowRootItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
              rowRootItemId               = rowData[ rowRootItemIdDataDescriptor?.alias ],
              rowRootItem                 = global.data[ dataContext ]?.items[ rowRootItemId ],
              rowIndex                    = value.findIndex( vRowData => JSON.stringify( vRowData ) === JSON.stringify( rowData ) );

        if ( rowRootItem ) {
            // clear all editValues for row
            const {
                      columnDefinitions
                  }                = this.props,
                  cellEditorValues = { ...elusiveData?.cellEditorValues ?? {} };

            if ( rowIndex ) {
                for ( const columnDefinition of columnDefinitions ) {
                    delete cellEditorValues[ DataTable.getCellId( rowIndex, columnDefinition.field ) ];
                }
                this.props.setElusiveData( uid, { cellEditorValues } );
            }

            switch ( type ) {
                case 'delete':
                    this.props.deleteItem( dataContext, rowRootItemId, true, [ uid ], true, true );
                    break;

                case 'restore':
                    this.props.addItem( dataContext, rowRootItem, schema, [ uid ] );
                    break;
            }
        }
    }


    /* private ****************************************************************************************************************************/

    /**
     * Init
     *
     * @private
     */
    init() {
        this.props.setParam( this.props.uid, 'moduleTransformer', 'overview' );
    }

    /**
     * load the overview configuration from the backend
     *
     * @private
     */
    async loadConfig() {
        const {
                  uid,
                  schema,
                  viewKey,
                  search,
                  showViewAsConfigured
              }                             = this.props,
              params : LoadConfigParameters = {
                  schema,
                  viewKey: viewKey
              };

        const response = await xhr.post(
            `${BASE_URL}/api/overview/loadConfig`,
            params,
            undefined,
            uid,
            Overview.configRequestUid
        );

        if ( response?.data ) {
            const config                     = response.data as LoadConfigResult,
                  asConfiguredViewPanelProps = {
                      ...this.props.defaultProps,
                      search
                  },
                  currentViewPanelProps      = {
                      ...extractViewPropsFromProps( this.props ),
                      forceFit: asConfiguredViewPanelProps.forceFit
                  },
                  isViewAsConfigured         = viewSelectorPanelPropsCompare( asConfiguredViewPanelProps, currentViewPanelProps ),
                  isNewPanel                 = !this.props.columns.length;

            let paramsToSet : Partial<ComponentProps> = {
                actions                : config.data.actions,
                columnDefinitions      : config.data.columnDefinitions,
                columnKeyToFieldMapping: config.data.columnKeyToFieldMapping,
                configHash             : config.data.configHash,
                dataStructure          : config.data.dataStructure,
                deletable              : config.data.deletable,
                editable               : config.data.editable,
                filterable             : config.data.filterable,
                fixFilters             : config.data.fixFilters,
                functions              : config.data.functions,
                groupingColumn         : config.data.groupingColumn,
                groupingHeader         : config.data.groupingHeader as string,
                initialGroupState      : config.data.initialGroupState,
                linkTarget             : config.data.linkTarget,
                openDetailViewConfig   : config.data.openDetailViewConfig,
                panelConfigIds         : config.data.panelConfigIds,
                queryType              : config.data.queryType,
                reorderable            : config.data.reorderable,
                resizable              : config.data.resizable,
                rowStyling             : config.data.rowStyling,
                rows                   : config.data.rowsPerPage,
                schema                 : config.data.schema ?? schema,
                sortable               : config.data.sortable,
                usePaging              : config.data.usePaging
            };

            // initialized panel and not view as configured -> just reload
            if ( !isNewPanel && !isViewAsConfigured ) {
                paramsToSet.doSearch = this.props.search;
            }

            // init panel
            else {
                let defaultViewProps                   = showViewAsConfigured ? {} : getDefaultViewProps( viewKey, config.data.columnDefinitions ),
                    showConfigChangedWarning : boolean = false;

                paramsToSet.defaultProps = {
                    columns   : [] as ColumnConfig[],
                    doSearch  : true,
                    autoLayout: config.data.autoLayout,
                    forceFit  : config.data.forceFit,
                    editMode  : config.data.editMode
                };

                if ( config.data.defaultFilters?.length ) {
                    paramsToSet.defaultProps.filters = config.data.defaultFilters;
                }

                if ( config.data.fixFilters?.length ) {
                    paramsToSet.defaultProps.fixFilters = config.data.fixFilters;
                }

                if ( config.data.defaultSorters?.length ) {
                    paramsToSet.defaultProps.sorters = config.data.defaultSorters;
                }

                if ( config.data.rowStyling?.length ) {
                    paramsToSet.defaultProps.rowStyling = config.data.rowStyling;
                }

                for ( const columnDefinition of config.data.columnDefinitions ) {
                    if ( !columnDefinition.hidden ) {
                        paramsToSet.defaultProps.columns!.push( getColumnConfigFromColumnDefinition( columnDefinition ) );
                    }
                }

                if ( isNewPanel && Object.keys( defaultViewProps ).length ) {
                    if ( defaultViewProps.overviewConfigHash !== config.data.configHash ) {
                        showConfigChangedWarning = true;
                    }

                    defaultViewProps = buildPropsFromViewProps( defaultViewProps );
                }

                paramsToSet = {
                    ...paramsToSet.defaultProps,
                    ...defaultViewProps,
                    ...paramsToSet
                };

                if ( showConfigChangedWarning ) {
                    this.props.setMessage?.(
                        uid,
                        'toast',
                        'configChanged',
                        { id: 'showWarn' }
                    );
                }
            }

            this.props.setParams( uid, paramsToSet );

            // clear changedCellValues
            this.props.unsetElusiveData( uid, [ 'changedCellValues' ] );

            if ( this.props.onConfigLoad ) {
                this.props.onConfigLoad( config );
            }
        }
    }

    getLoadDataParameters( props? : DataTableAllProps ) : LoadDataParameters {
        const {
                  additionalQueryParameters,
                  configHash,
                  schema,
                  usePaging,
                  viewKey
              } = this.props,
              {
                  columns,
                  page,
                  rows,
                  searchString,
                  sorters
              } = props ?? this.props;

        return {
            schema,
            viewKey,
            configHash,

            searchString,
            columns   : columns.map( column => column.field ),
            filters   : this.getApplyableFilters( props ),
            sorters   : sorters,
            start     : usePaging
                ? ( page - 1 ) * rows
                : 0,
            limit     : usePaging
                ? rows
                : -1,
            parameters: additionalQueryParameters
        };
    }

    /**
     * Creates the add reference button for action columns header.
     *
     * @param {Schema} schema
     * @param {DataStructure} dataStructure
     * @param {boolean} deletable
     * @param {User} user
     *
     * @return {ActionColumns}
     */
    getActionColumns( schema : Schema, dataStructure : DataStructure, deletable : boolean, user : User ) : ActionColumns {
        const retVal : ActionColumns = {};

        if ( dataStructure.item ) {
            const rootItemSchema    = ( dataStructure.item.objectSchema?.toUpperCase() ?? schema ?? 'DATA' ) as Schema,
                  rootItemTypeName  = dataStructure.item.objectType ?? '',
                  rootItemDeletable = user.hasPermissionOnItemType( 'delete', rootItemTypeName, rootItemSchema ) ?? false,
                  width : number    = 28;

            let field : string;

            if ( deletable && rootItemDeletable ) {
                field = 'restoreDelete';

                retVal[ field ] = {
                    width,
                    column: <Column
                        body={this.restoreDeleteCellRenderer}

                        field={field}
                        bodyClassName="yn-nowrap-top-column yn-nopadding-column yn-action-column"
                        headerClassName="yn-header-action-column"
                        filterHeaderClassName="yn-header-action-column"
                        reorderable={false}
                        resizeable={false}
                        sortable={false}
                    />
                };
            }
        }

        return retVal;
    }

    /**
     * renderer for action column
     *
     * @param {{ rowData : LoadMetaDataRowData }} data
     *
     * @return {JSX.Element | string | undefined}
     */
    restoreDeleteCellRenderer( data : { rowData : LoadMetaDataRowData } ) : JSX.Element | string | undefined {
        let retVal : JSX.Element | string | undefined = '';

        const {
                  dataContext,
                  dataStructure
              }                           = this.props,
              rowData                     = data.rowData,
              rowRootItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
              rowRootItemId               = rowData[ rowRootItemIdDataDescriptor?.alias ],
              rowRootItem                 = global.data[ dataContext ]?.items[ rowRootItemId ];

        if ( rowRootItem ) {
            let icon,
                className,
                onClickHandler,
                enabled = false;

            if ( rowRootItem.isDeleted() ) {
                icon = 'pi pi-plus-circle';
                className = 'yn-action-button yn-green-button';

                onClickHandler = this.onRestoreDeleteAction.bind( this, 'restore', rowData );

                enabled = true;
            }

            // delete
            else {
                icon = 'pi pi-minus-circle';
                className = 'yn-action-button yn-red-button';

                onClickHandler = this.onRestoreDeleteAction.bind( this, 'delete', rowData );

                enabled = true;
            }

            if ( className ) {
                retVal = <Button
                    onClick={
                        enabled
                            ? onClickHandler
                            : () => {
                            }
                    }

                    disabled={!enabled}

                    icon={icon}
                    className={`${className}`}
                />;
            }
        }

        return retVal;
    }

    getApplyableFilters( props? : DataTableAllProps ) : ColumnFilter[] {
        const retVal : ColumnFilter[] = [],
              {
                  filters,
                  fixFilters,
                  elusiveData
              }                       = props ?? this.props,
              filtersToUse            = elusiveData?.newFilters ?? filters;


        // filter out empty filters
        if ( fixFilters ) {
            for ( let i = fixFilters.length - 1; i >= 0; i-- ) {
                if ( !!fixFilters[ i ].value || fixFilters[ i ].operator === 'empty' || fixFilters[ i ].operator === 'notEmpty' ) {
                    retVal.push( fixFilters[ i ] );
                }
            }
        }
        if ( filtersToUse ) {
            for ( let i = filtersToUse.length - 1; i >= 0; i-- ) {
                if (
                    !retVal.find( filter => filter.field === filtersToUse[ i ].field )
                    && ( !!filtersToUse[ i ].value || filtersToUse[ i ].operator === 'empty' || filtersToUse[ i ].operator === 'notEmpty' )
                ) {
                    retVal.push( filtersToUse[ i ] );
                }
            }
        }

        return retVal;
    }

    getSearchColumns( columnDefinitions : ColumnDefinition[] ) : string[] {
        return columnDefinitions.reduce(
            ( innerRetVal, columnDefinition ) => {
                if ( columnDefinition.searchColumn ) {
                    innerRetVal.push( columnDefinition.field );
                }
                return innerRetVal;
            },
            [] as string[] );
    }

    getColumnGrouping( groupingColumn? : string, groupingHeader? : string ) : Pick<DataTableComponentProps, 'rowGroupMode' | 'groupRowsBy' | 'rowGroupHeaderTemplate' | 'expandableRowGroups'> | undefined {
        let retVal : Pick<DataTableComponentProps, 'rowGroupMode' | 'groupRowsBy' | 'rowGroupHeaderTemplate' | 'expandableRowGroups'> | undefined = undefined;

        if ( groupingColumn ) {
            retVal = {
                rowGroupMode          : 'subheader',
                groupRowsBy           : `rowData.${groupingColumn}`,
                expandableRowGroups   : true,
                rowGroupHeaderTemplate: ( rowData : any, options : any ) => {
                    const {
                              expandedRows
                          } = this.props;

                    let innerRetVal : React.ReactNode | string = '';

                    if ( !groupingHeader ) {
                        innerRetVal = rowData.rowData[ groupingColumn ];
                    }
                    else {
                        const expanded = Array.isArray( expandedRows ) && expandedRows.find( eR => Object.values( eR )?.[ 0 ] === rowData.rowData[ groupingColumn ] ),
                              icon     = IconUtils.getJSXIcon(
                                  expanded
                                      ? <ChevronDownIcon/>
                                      : <ChevronRightIcon/>,
                                  {},
                                  {}
                              ),
                              toggler  = `<button type="button" className="p-row-toggler p-link"></button>`;

                        let customTooltip : string | undefined = undefined;

                        innerRetVal = messageUtils.getMessageTemplateStringResolverForData( { ...rowData.rowData }, { rowData, options, renderToString, toggler } )( __( groupingHeader as string ) );

                        if ( !isInvalidHTML( innerRetVal as string ) ) {
                            const tooltipMatch = ( innerRetVal as string ).match( /data-pr-tooltip="([^"]*)"/ );

                            if ( tooltipMatch?.[ 1 ] ) {
                                customTooltip = tooltipMatch[ 1 ];
                                innerRetVal = ( innerRetVal as string ).replace( 'customTooltipElement', `customTooltipElement customTooltipElement_${options.index}` )
                            }

                            innerRetVal = parse( innerRetVal as string );

                            if ( Array.isArray( innerRetVal ) ) {
                                let replaced : boolean = false;

                                const recursiveSetTogglerOnClick = ( elements : React.JSX.Element[] ) => {
                                    for ( let i = 0; i < elements.length; i++ ) {
                                        if ( elements[ i ].props?.type === 'button' && elements[ i ].props?.className === 'p-row-toggler p-link' ) {
                                            elements[ i ] = <button type="button" className="p-row-toggler p-link" aria-label="Collapse"
                                                                    onClick={this.onRowToggle.bind( this, rowData.rowData[ groupingColumn ] )}>{icon}</button>;
                                            replaced = true;
                                        }
                                        else if ( elements[ i ].props?.children?.length ) {
                                            recursiveSetTogglerOnClick( elements[ i ].props.children );
                                        }

                                        if ( replaced ) {
                                            break;
                                        }
                                    }
                                };

                                recursiveSetTogglerOnClick( innerRetVal );

                                if ( !expanded && customTooltip ) {
                                    innerRetVal.unshift( <Tooltip
                                        key="cellTooltip"
                                        target={`.customTooltipElement.customTooltipElement_${options.index}`}
                                        my="left top"
                                        at="left bottom"
                                        className="yn-tooltip"
                                        showDelay={250}
                                    >
                                        {customTooltip}
                                    </Tooltip> );
                                }
                            }
                        }
                    }

                    return innerRetVal;
                }
            }
        }

        return retVal;
    }

    /**
     * load the overview data from the backend
     *
     * @private
     */
    loadData( props? : DataTableAllProps, force : boolean = false ) : boolean {
        // proceed only if config loaded
        if ( this.props.columnDefinitions.length && this.props.dataStructure ) {
            const doLoadData = async () => {
                const {
                          actions,
                          dataContext,
                          elusiveData,
                          groupingColumn,
                          initialGroupState,
                          loadDataRoute,
                          mode,
                          schema,
                          treeVariables,
                          uid
                      }          = this.props,
                      lastParams = elusiveData?.lastParams ?? '',
                      filters    = props
                          ? props.elusiveData?.newFilters ?? props.filters
                          : this.props.elusiveData?.newFilters ?? this.props.filters;

                let params = this.getLoadDataParameters( props );

                // execute changeParams actions
                if ( actions?.length ) {
                    let aborted : boolean = false;

                    delete this.dynamicFunctionGlobalParameters;

                    for ( const action of actions ) {
                        if ( action.type === 'changeParams' && action.function ) {
                            try {
                                const result = await this.buildDynamicFunction(
                                    {
                                        ...getResolvedConfigs( action.configs ?? {} ),
                                        parameters: { ...params },
                                        treeVariables,
                                        getRowId  : DataTable.getRowId
                                    },
                                    action.function,
                                    {}
                                )();

                                if ( result ) {
                                    params = result;
                                }
                            }
                            catch ( e ) {
                                console.error( e, {
                                    function           : action.function,
                                    resolvedDataObjects: {}
                                } );

                                const errorTitle  = `<span class="yn-error yn-confirmpopup-title">${__(
                                          'YN.base.form.executeAction.error.title',
                                          {
                                              id  : String( action.id ) ?? '',
                                              key : action.key ?? `order: ${action.order}`,
                                              name: action.name ?? ''
                                          }
                                      )}</span>`,
                                      errorDetail = this.getDynamicFunctionErrorDetail( e, action.function );

                                // wait on error
                                await new Promise( ( resolve ) => {
                                    confirmPopup( {
                                        target         : document.getElementById( `${uid}_datatable` )?.querySelector( '.p-datatable-wrapper' ) ?? document.body,
                                        content        : '',
                                        message        : parse( `${errorTitle}<br /><br />${errorDetail}` ),
                                        icon           : 'pi pi-exclamation-triangle yn-error',
                                        acceptLabel    : __( 'YN.base.common.ok' ),
                                        acceptClassName: 'p-button p-button-outlined',
                                        rejectClassName: 'hidden',
                                        accept         : () => {
                                            resolve( true );
                                        }
                                    } );
                                } );

                                aborted = true;

                                break;
                            }
                        }
                    }

                    // apply modifications
                    if ( !aborted ) {
                        try {
                            if ( treeVariables ) {
                                this.props.treeSetVariables?.( treeVariables );
                            }
                            this.applyDynamicFunctionVariablesChanges( this.props );
                        }
                        catch ( e ) {
                            console.error( e );
                        }
                    }
                }

                // search parameters or page changed
                if ( force || ( lastParams !== 'requested' && ( JSON.stringify( params ) !== JSON.stringify( lastParams ) || !global.data[ dataContext ] ) ) ) {

                    this.props.setParam( uid, 'filters', filters );

                    // clear cell edit data
                    this.props.unsetElusiveData( uid, dataTableCellEditorDataKeys );

                    // clear new filters
                    this.props.unsetElusiveData( uid, [ 'newFilters' ] );

                    try {
                        await this.props.loadData(
                            loadDataRoute,
                            dataContext,
                            uid,
                            Overview.dataRequestUid,
                            schema,
                            {
                                params,
                                mergeMode        : mode === 'standalone' ? 'override' : 'keepLoaded',
                                extraMetaDataKeys: [ 'rowData', 'rowDataMapping', 'total' ]
                            },
                            true,
                            async ( ...args ) => {
                                const stringifiedRowData           = JSON.stringify( args?.[ 0 ]?.metaData?.rowData ?? [] ),
                                      stringifiedChangedCellValues = JSON.stringify( elusiveData?.changedCellValues ?? {} ),
                                      changedCellValues            = JSON.parse( stringifiedChangedCellValues );

                                let rowData = JSON.parse( stringifiedRowData );

                                // execute changeData actions
                                if ( actions?.length ) {
                                    let aborted : boolean = false;

                                    delete this.dynamicFunctionGlobalParameters;

                                    for ( const action of actions ) {
                                        if ( action.type === 'changeData' && action.function ) {
                                            try {
                                                const result = await this.buildDynamicFunction(
                                                    {
                                                        ...getResolvedConfigs( action.configs ?? {} ),
                                                        action  : {
                                                            type: 'load'
                                                        },
                                                        rowData,
                                                        changedCellValues,
                                                        treeVariables,
                                                        getRowId: DataTable.getRowId
                                                    },
                                                    action.function,
                                                    {}
                                                )();

                                                if ( result ) {
                                                    rowData = result;
                                                }
                                            }
                                            catch ( e ) {
                                                console.error( e, {
                                                    function           : action.function,
                                                    resolvedDataObjects: {}
                                                } );

                                                const errorTitle  = `<span class="yn-error yn-confirmpopup-title">${__(
                                                          'YN.base.form.executeAction.error.title',
                                                          {
                                                              id  : String( action.id ) ?? '',
                                                              key : action.key ?? `order: ${action.order}`,
                                                              name: action.name ?? ''
                                                          }
                                                      )}</span>`,
                                                      errorDetail = this.getDynamicFunctionErrorDetail( e, action.function );

                                                // wait on error
                                                await new Promise( ( resolve ) => {
                                                    confirmPopup( {
                                                        target         : document.getElementById( `${uid}_datatable` )?.querySelector( '.p-datatable-wrapper' ) ?? document.body,
                                                        content        : '',
                                                        message        : parse( `${errorTitle}<br /><br />${errorDetail}` ),
                                                        icon           : 'pi pi-exclamation-triangle yn-error',
                                                        acceptLabel    : __( 'YN.base.common.ok' ),
                                                        acceptClassName: 'p-button p-button-outlined',
                                                        rejectClassName: 'hidden',
                                                        accept         : () => {
                                                            resolve( true );
                                                        }
                                                    } );
                                                } );

                                                aborted = true;

                                                break;
                                            }
                                        }
                                    }

                                    // apply modifications
                                    if ( !aborted ) {
                                        try {
                                            if ( JSON.stringify( rowData ) !== stringifiedRowData ) {
                                                this.props.setElusiveData(
                                                    uid,
                                                    {
                                                        metaData: {
                                                            ...elusiveData?.metaData,
                                                            rowData
                                                        }
                                                    }
                                                );
                                            }
                                            if ( JSON.stringify( changedCellValues ) !== stringifiedChangedCellValues ) {
                                                this.props.setElusiveData( uid, { changedCellValues } );
                                            }
                                            if ( treeVariables ) {
                                                this.props.treeSetVariables?.( treeVariables );
                                            }
                                            this.applyDynamicFunctionVariablesChanges( this.props );
                                        }
                                        catch ( e ) {
                                            console.error( e );
                                        }
                                    }
                                }

                                // expand all grouped rows
                                if ( groupingColumn && initialGroupState === 'expanded' && rowData.length ) {
                                    const newExpandedRows : DataTableComponentProps[ 'expandedRows' ] = [];

                                    for ( const row of rowData ) {
                                        if ( !newExpandedRows.find( eR => Object.values( eR )?.[ 0 ] === row[ groupingColumn ] ) ) {
                                            newExpandedRows.push( { [ `rowData.${groupingColumn}` ]: row[ groupingColumn ] } );
                                        }
                                    }

                                    this.props.setParam( uid, 'expandedRows', newExpandedRows );
                                }

                                if ( this.props.onDataLoad ) {
                                    if ( args?.[ 0 ]?.metaData?.rowData ) {
                                        args[ 0 ].metaData.rowData = rowData;
                                    }

                                    this.props.onDataLoad( ...args );
                                }
                            }
                        );
                    }
                    catch ( e ) {
                        console.error( e );
                    }
                }
            }

            void doLoadData();
        }

        return true;
    }

    getEditForm() {
        const {
                  allElusiveData,
                  dataContext,
                  editable,
                  schema,
                  uid
              }                   = this.props,
              {
                  showEditItemDialog,
                  editItem,
                  editPanelConfig
              }                   = this.state,
              popupTitle          = '',
              editFormUid         = this.getEditFormUid(),
              editFormDataContext = this.getEditFormDataContext(),
              editFormProps       = this.getEditFormProps(),
              editFormElusiveData = allElusiveData?.[ editFormUid ];

        let retVal = null;

        if ( showEditItemDialog && editItem ) {
            retVal = <Dialog
                key={`${uid}_editItemDialog`}
                id={`${uid}_editItemDialog`}

                visible={true}
                onHide={this.onEditItemDialogHide}
                focusOnShow={false}
                closeOnEscape={false}
                className="yn-form-dialog"
                header={popupTitle ? __( popupTitle ) : __( 'YN.base.frontend.overview.popup.title', { itemTypeName: metaModel[ schema ].getItemType( editItem.itemTypeId )?.label ?? '' } )}
                footer={<div>
                    {editable &&
                        <Button
                            id={`${editFormUid}_okButton`}
                            key="okButton"
                            label={__( 'YN.base.common.ok' )}
                            className="p-button-outlined mr-3"
                            disabled={editFormElusiveData?.errorData?.count ?? 1}
                            onClick={this.onEditItemDialogOkButtonClick}
                        />
                    }
                    {editable &&
                        <Button
                            id={`${editFormUid}_cancelButton`}
                            key="cancelButton"
                            label={__( 'YN.base.common.cancel' )}
                            className="p-button-secondary p-button-outlined"
                            onClick={this.onEditItemDialogCancelButtonClick}
                        />
                    }
                    {!editable &&
                        <Button
                            id={`${editFormUid}_closeButton`}
                            key="closeButton"
                            label={__( 'YN.base.common.close' )}
                            className="p-button-outlined"
                            onClick={this.onEditItemDialogCancelButtonClick}
                        />
                    }
                </div>}
            >
                <LoadingMaskPanel key={`${editFormUid}_loadingMask`} forComponent={editFormUid} className="yn-flex-layout-parent">
                    {( !!Object.keys( editPanelConfig ).length ) &&
                        <Form
                            key={editFormUid}
                            uid={editFormUid}
                            dataContext={editFormDataContext}
                            additionalCheckDataContexts={[ dataContext ]}

                            schema={schema}
                            viewKey={editPanelConfig.viewKey}
                            rootItemId={editItem.id}
                            mode="popup"
                            readOnly={!editable}

                            onDataLoad={() => {
                                this.setState( { forceRender: this.state.forceRender + 1 } );
                            }}

                            {...editFormProps}
                        />
                    }
                    {( !Object.keys( editPanelConfig ).length ) &&
                        <GenericForm
                            key={editFormUid}
                            uid={editFormUid}
                            dataContext={editFormDataContext}
                            additionalCheckDataContexts={[ dataContext ]}

                            schema={schema}
                            item={editItem}
                            editable={editable}

                            onErrorDataChanged={() => {
                                this.setState( { forceRender: this.state.forceRender + 1 } );
                            }}

                            {...editFormProps}
                        />
                    }
                </LoadingMaskPanel>
            </Dialog>;
        }

        return retVal;
    }

    getEditFormUid() {
        return `${this.props.uid}_editItemDialogForm`;
    }

    getEditFormDataContext() {
        return `${this.getEditFormUid()}-dataContext`;
    }

    getEditFormProps() {
        return getSubPanelProps( this.getEditFormUid() );
    }

    hideEditItemDialog() {
        const {
                  dataContext
              }                   = this.props,
              editFormUid         = this.getEditFormUid(),
              editFormDataContext = this.getEditFormDataContext();

        if ( editFormDataContext !== dataContext ) {
            delete global.data[ editFormDataContext ];
        }

        this.setState( {
            showEditItemDialog: false,
            editItem          : undefined
        } );

        setTimeout(
            () => {
                this.props.clearPanelProps( editFormUid );
                this.props.clearElusiveData( editFormUid );
                this.props.clearElusiveDataForSubpanels( editFormUid );
            },
            1
        );
    }

    onEditItemDialogHide() {
        this.hideEditItemDialog();
    }

    onEditItemDialogOkButtonClick( event : React.MouseEvent<HTMLButtonElement, MouseEvent> ) {
        const {
                  uid,
                  dataContext
              }                                            = this.props,
              {
                  editItem
              }                                            = this.state,
              editFormDataContext                          = this.getEditFormDataContext(),
              itemIdMapping : { [ id : number ] : number } = {};

        this.setState( { showEditItemDialog: false } );

        if ( editItem ) {
            const items      = Object.values( global.data[ editFormDataContext ].items ?? {} ),
                  references = Object.values( global.data[ editFormDataContext ].references ?? {} );

            for ( const item of items ) {
                // update existing/new item
                if ( global.data[ dataContext ].items[ item.id ] ) {
                    const itemToUpdate = global.data[ dataContext ].items[ item.id ];

                    if ( item.isDeleted() ) {
                        if ( item.statusId !== itemToUpdate.statusId ) {
                            this.props.deleteItem(
                                dataContext,
                                item.id,
                                true,
                                [ uid ]
                            );
                        }
                    }
                    else {
                        if ( JSON.stringify( item.toUpdateJSON( 'modified' ) ) !== JSON.stringify( itemToUpdate.toUpdateJSON( 'modified' ) ) ) {
                            const itemData = actionMixin.getUpdateDataWithRemovedNewProperties( itemToUpdate, item, false );

                            this.props.updateItem(
                                dataContext,
                                item.id,
                                itemData,
                                [ uid ]
                            );
                        }
                    }
                }
                // add existing item
                else if ( item.id > 0 ) {
                    let itemData : ItemAttributesSettable | undefined;

                    if ( item.isModified() ) {
                        itemData = item.toUpdateJSON( 'modified' );

                        item.reset();
                    }

                    this.props.addItem(
                        dataContext,
                        { ...item.toJSON( 'all' ) } as ItemAttributesForCreation,
                        schema,
                        [ uid ]
                    );

                    if ( itemData ) {
                        this.props.updateItem(
                            dataContext,
                            item.id,
                            itemData,
                            [ uid ]
                        );

                        item.update( itemData );
                    }
                }
                // add new item
                else {
                    const newItem  = this.props.addItem(
                              dataContext,
                              { itemTypeId: item.itemTypeId } as ItemAttributesForCreation,
                              schema,
                              [ uid ]
                          ),
                          itemData = item.toUpdateJSON( 'all' );

                    this.props.updateItem(
                        dataContext,
                        newItem.id,
                        itemData,
                        [ uid ]
                    );

                    // add id mapping
                    itemIdMapping[ item.id ] = newItem.id;
                }
            }

            for ( const reference of references ) {
                // update existing/new reference
                if ( global.data[ dataContext ].references[ reference.id ] ) {
                    const referenceToUpdate = global.data[ dataContext ].references[ reference.id ];

                    if ( reference.isDeleted() ) {
                        if ( reference.statusId !== referenceToUpdate.statusId ) {
                            this.props.deleteReference(
                                dataContext,
                                reference.id,
                                true,
                                [ uid ]
                            );
                        }
                    }
                    else {
                        if ( JSON.stringify( reference.toUpdateJSON( 'modified' ) ) !== JSON.stringify( referenceToUpdate.toUpdateJSON( 'modified' ) ) ) {
                            const referenceData = actionMixin.getUpdateDataWithRemovedNewProperties( referenceToUpdate, reference, false );

                            this.props.updateReference(
                                dataContext,
                                reference.id,
                                referenceData,
                                [ uid ]
                            );
                        }
                    }
                }
                // add existing reference
                else if ( reference.id > 0 ) {
                    let referenceData : ReferenceAttributesSettable | undefined;

                    if ( reference.isModified() ) {
                        referenceData = reference.toUpdateJSON( 'modified' );

                        reference.reset();
                    }

                    this.props.addReference(
                        dataContext,
                        { ...reference.toJSON( 'all' ) } as ReferenceAttributesForCreation,
                        schema,
                        [ uid ]
                    );

                    if ( referenceData ) {
                        this.props.updateReference(
                            dataContext,
                            reference.id,
                            referenceData,
                            [ uid ]
                        );

                        reference.update( referenceData );
                    }
                }
                // add new reference
                else {
                    const newReference  = this.props.addReference(
                              dataContext,
                              {
                                  referenceSetId: reference.referenceSetId,
                                  srcItemId     : itemIdMapping[ reference.srcItemId ] ?? reference.srcItemId,
                                  destItemId    : itemIdMapping[ reference.destItemId ] ?? reference.destItemId
                              } as ReferenceAttributesForCreation,
                              schema,
                              [ uid ]
                          ),
                          referenceData = reference.toUpdateJSON( 'all' );

                    this.props.updateReference(
                        dataContext,
                        newReference.id,
                        referenceData,
                        [ uid ]
                    );
                }
            }
        }

        this.hideEditItemDialog();
    }

    onEditItemDialogCancelButtonClick() {
        this.hideEditItemDialog();
    }

    async onRowDataChange( field : string, value : string, inRowData : LoadMetaDataRowData, event : React.SyntheticEvent, inChangedCellValues : ChangedCellValues ) {
        const {
                  uid,
                  actions,
                  treeVariables,
                  elusiveData
              }                            = this.props,
              stringifiedRowData           = JSON.stringify( elusiveData?.metaData?.rowData ?? [] ),
              stringifiedChangedCellValues = JSON.stringify( inChangedCellValues ?? {} ),
              changedCellValues            = JSON.parse( stringifiedChangedCellValues );

        let rowData = JSON.parse( stringifiedRowData );

        // execute changeData actions
        if ( actions?.length ) {
            let aborted : boolean = false;

            delete this.dynamicFunctionGlobalParameters;

            for ( const action of actions ) {
                if ( action.type === 'changeData' && action.function ) {
                    try {
                        const result = await this.buildDynamicFunction(
                            {
                                ...getResolvedConfigs( action.configs ?? {} ),
                                action  : {
                                    type   : 'change',
                                    field,
                                    value,
                                    rowData: inRowData
                                },
                                rowData,
                                changedCellValues,
                                treeVariables,
                                getRowId: DataTable.getRowId
                            },
                            action.function,
                            {}
                        )();

                        if ( result ) {
                            rowData = result;
                        }
                    }
                    catch ( e ) {
                        console.error( e, {
                            function           : action.function,
                            resolvedDataObjects: {}
                        } );

                        const errorTitle  = `<span class="yn-error yn-confirmpopup-title">${__(
                                  'YN.base.form.executeAction.error.title',
                                  {
                                      id  : String( action.id ) ?? '',
                                      key : action.key ?? `order: ${action.order}`,
                                      name: action.name ?? ''
                                  }
                              )}</span>`,
                              errorDetail = this.getDynamicFunctionErrorDetail( e, action.function );

                        // wait on error
                        await new Promise( ( resolve ) => {
                            confirmPopup( {
                                target         : document.getElementById( `${uid}_datatable` )?.querySelector( '.p-datatable-wrapper' ) ?? document.body,
                                content        : '',
                                message        : parse( `${errorTitle}<br /><br />${errorDetail}` ),
                                icon           : 'pi pi-exclamation-triangle yn-error',
                                acceptLabel    : __( 'YN.base.common.ok' ),
                                acceptClassName: 'p-button p-button-outlined',
                                rejectClassName: 'hidden',
                                accept         : () => {
                                    resolve( true );
                                }
                            } );
                        } );

                        aborted = true;

                        break;
                    }
                }
            }

            // apply modifications
            if ( !aborted ) {
                try {
                    if ( JSON.stringify( rowData ) !== stringifiedRowData ) {
                        this.props.setElusiveData(
                            uid,
                            {
                                metaData: {
                                    ...elusiveData?.metaData,
                                    rowData
                                }
                            }
                        );
                    }
                    if ( JSON.stringify( changedCellValues ) !== stringifiedChangedCellValues ) {
                        this.props.setElusiveData( uid, { changedCellValues } );
                    }
                    if ( treeVariables ) {
                        this.props.treeSetVariables?.( treeVariables );
                    }
                    this.applyDynamicFunctionVariablesChanges( this.props );
                }
                catch ( e ) {
                    console.error( e );
                }
            }
        }

        void this.props.onRowDataChange?.( field, value, inRowData, event, changedCellValues );
    }

    async onRowDataRevert( field : string, inRowData : LoadMetaDataRowData, event : React.SyntheticEvent, inChangedCellValues : ChangedCellValues ) {
        const {
                  uid,
                  actions,
                  treeVariables,
                  elusiveData
              }                            = this.props,
              stringifiedRowData           = JSON.stringify( elusiveData?.metaData?.rowData ?? [] ),
              stringifiedChangedCellValues = JSON.stringify( inChangedCellValues ?? {} ),
              changedCellValues            = JSON.parse( stringifiedChangedCellValues );

        let rowData = JSON.parse( stringifiedRowData );

        // execute changeData actions
        if ( actions?.length ) {
            let aborted : boolean = false;

            delete this.dynamicFunctionGlobalParameters;

            for ( const action of actions ) {
                if ( action.type === 'changeData' && action.function ) {
                    try {
                        const result = await this.buildDynamicFunction(
                            {
                                ...getResolvedConfigs( action.configs ?? {} ),
                                action  : {
                                    type   : 'revert',
                                    field,
                                    rowData: inRowData
                                },
                                rowData,
                                changedCellValues,
                                treeVariables,
                                getRowId: DataTable.getRowId
                            },
                            action.function,
                            {}
                        )();

                        if ( result ) {
                            rowData = result;
                        }
                    }
                    catch ( e ) {
                        console.error( e, {
                            function           : action.function,
                            resolvedDataObjects: {}
                        } );

                        const errorTitle  = `<span class="yn-error yn-confirmpopup-title">${__(
                                  'YN.base.form.executeAction.error.title',
                                  {
                                      id  : String( action.id ) ?? '',
                                      key : action.key ?? `order: ${action.order}`,
                                      name: action.name ?? ''
                                  }
                              )}</span>`,
                              errorDetail = this.getDynamicFunctionErrorDetail( e, action.function );

                        // wait on error
                        await new Promise( ( resolve ) => {
                            confirmPopup( {
                                target         : document.getElementById( `${uid}_datatable` )?.querySelector( '.p-datatable-wrapper' ) ?? document.body,
                                content        : '',
                                message        : parse( `${errorTitle}<br /><br />${errorDetail}` ),
                                icon           : 'pi pi-exclamation-triangle yn-error',
                                acceptLabel    : __( 'YN.base.common.ok' ),
                                acceptClassName: 'p-button p-button-outlined',
                                rejectClassName: 'hidden',
                                accept         : () => {
                                    resolve( true );
                                }
                            } );
                        } );

                        aborted = true;

                        break;
                    }
                }
            }

            // apply modifications
            if ( !aborted ) {
                try {
                    if ( JSON.stringify( rowData ) !== stringifiedRowData ) {
                        this.props.setElusiveData(
                            uid,
                            {
                                metaData: {
                                    ...elusiveData?.metaData,
                                    rowData
                                }
                            }
                        );
                    }
                    if ( JSON.stringify( changedCellValues ) !== stringifiedChangedCellValues ) {
                        this.props.setElusiveData( uid, { changedCellValues } );
                    }
                    if ( treeVariables ) {
                        this.props.treeSetVariables?.( treeVariables );
                    }
                    this.applyDynamicFunctionVariablesChanges( this.props );
                }
                catch ( e ) {
                    console.error( e );
                }
            }
        }

        void this.props.onRowDataRevert?.( field, inRowData, event, changedCellValues );
    }

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  columnDefinitions,
                  dataStructure,
                  defaultProps: overviewDefaultProps,
                  editable,
                  elusiveData,
                  deletable,
                  filterable,
                  groupingColumn,
                  groupingHeader,
                  mode,
                  queryType,
                  readOnly,
                  schema,
                  search,
                  toolbarVisibility,
                  uid,
                  user,
                  usePaging,
                  xhrRequestsForComponent
              }                                                           = this.props,
              {
                  errorCount,
                  errorTooltip
              }                                                           = this.state,
              searchColumns                                               = this.getSearchColumns( columnDefinitions ),
              columnGrouping                                              = this.getColumnGrouping( groupingColumn, groupingHeader ),
              toolbarProps : ToolbarComponentProps & { key : string }     = {
                  ..._.pick( this.props, toolbarComponentProps ) as ToolbarComponentProps,

                  key: `${uid}_toolbar`,

                  overviewRef: this,

                  showSaveButton        : mode === 'standalone',
                  showAddButton         : editable,
                  saveButtonErrorCount  : errorCount,
                  saveButtonErrorTooltip: errorTooltip,

                  showSearchField         : !!searchColumns.length,
                  showClearSearchButton   : filterable,
                  exportLoadDataParameters: this.getLoadDataParameters(),

                  viewSelectorAsConfiguredPanelProps: {
                      ...overviewDefaultProps,
                      search
                  },
                  viewSelectorPanelProps            : {
                      ...extractViewPropsFromProps( this.props )
                  },


                  className: `${mode !== 'embedded' ? '' : 'yn-panel-toolbar-border-none-bottom'}`
              },
              dataTableProps : DataTableComponentProps & { key : string } = {
                  ..._.pick( this.props, dataTableComponentProps ) as DataTableComponentProps,
                  editable: editable && !readOnly,

                  editType: queryType !== 'DataStructure' && editable && !readOnly ? 'rowData' : 'data',

                  key: `${uid}_dataTable`,

                  loading          : !!xhrRequestsForComponent,
                  value            : elusiveData?.metaData?.rowData ?? [],
                  valueFieldMapping: elusiveData?.metaData?.rowDataMapping ?? {},
                  totalRecords     : elusiveData?.metaData?.total ?? 0,

                  usePaging,
                  searchColumns,

                  ...columnGrouping,
                  actionColumns: this.getActionColumns( schema, dataStructure, deletable, user! ),

                  getApplyableFilters: this.getApplyableFilters,
                  reload             : this.loadData,
                  onRowClick         : this.onRowClick,
                  onRowDataChange    : this.onRowDataChange,
                  onRowDataRevert    : this.onRowDataRevert,

                  className: `yn-datatable-full ${mode !== 'embedded' || toolbarVisibility === 'hidden' ? '' : 'yn-flex yn-datatable-border-none-top'}`
              },
              editForm                                                    = this.getEditForm();

        // embedded mode
        if ( mode !== 'embedded' ) {
            return <>
                {editForm}
                {toolbarVisibility === 'visible' &&
                    <Toolbar
                        {...toolbarProps}
                    />
                }
                <DataTable
                    {...dataTableProps}
                />
            </>;
        }
        else {
            return <>
                {editForm}
                <div className="yn-card-content-panel yn-flex-layout-parent p-0">
                    <Card className="yn-flex-layout-parent" style={{ width: '100%', maxWidth: '100%' }}>
                        {toolbarVisibility === 'visible' &&
                            <Toolbar
                                {...toolbarProps}
                            />
                        }
                        <DataTable
                            {...dataTableProps}
                        />
                    </Card>
                </div>
            </>;
        }
    }
}

/**
 * REDUX stuff
 */
function mapStateToProps( state : StoreState, ownProps : ComponentProps ) : StateProps {
    const retVal : StateProps = {
        xhrRequestsForComponent: undefined,
        allElusiveData         : undefined,
        elusiveData            : undefined,
        user                   : undefined
    };

    // get all errors for subPanels
    retVal.allElusiveData = state.elusiveData;

    // get the running xhr request belonging to this component (uid)
    if ( state.xhr?.[ ownProps.uid ] ) {
        retVal.xhrRequestsForComponent = state.xhr[ ownProps.uid ];
    }

    // get elusiveData
    // for the data (items and references) belonging to this component
    if ( state.elusiveData?.[ ownProps.dataContext ] ) {
        retVal.elusiveData = {
            ...retVal.elusiveData ?? {},
            ...state.elusiveData[ ownProps.dataContext ]
        };
    }
    // for all other information belonging to this component
    if ( state.elusiveData?.[ ownProps.uid ] ) {
        retVal.elusiveData = {
            ...retVal.elusiveData ?? {},
            ...state.elusiveData[ ownProps.uid ]
        };
    }

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    return retVal;
}

/**
 * REDUX stuff
 */
function mapDispatchToProps( dispatch : Dispatch ) {
    return bindActionCreators( Actions, dispatch );
}

// apply mixin to Overview component
Object.assign( Overview.prototype, ActionMixin );

export default connect<StateProps, ActionProps, ComponentProps, StoreState>( mapStateToProps, mapDispatchToProps, undefined, { forwardRef: true } )( Overview );

